import React from "react";
import MCard from "components/Shared/MCard.tsx";

const BatchUploadErrors = ({ uploadErrors }) => {
  const getFileErrors = (errors) => {
    return errors.map((s, i) => ({ key: `batchError${i}`, label: (<li />), value: s, editable: false }));
  };

  return (
    <>
      {uploadErrors.map((s, i) => (
        <MCard
          key={`uploadErrorCard${i}`}
          title={`Batch Upload File Errors - ${s.file.name}`}
          fields={getFileErrors([...s.error])}
        />
      ))}
    </>
  );
};

export default BatchUploadErrors;